import { Reducer } from "redux";

import { ReferralMgmtSystemResponse } from "../models/Api/Master";
import { ReferralManagementSystemDispatchTypes } from "../models/DispatchTypes/Master";
import { ReferralManagementSystemActionDispatchTypes } from "../constants/Master";
import { setLocalStorageData } from "../utils";

export const initialState: ReferralMgmtSystemResponse = {
  loading: false,
  response: [],
};

const ReferralMgmtSystemReducer: Reducer<
    ReferralMgmtSystemResponse,
    ReferralManagementSystemDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ReferralManagementSystemActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SYSTEM_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ReferralManagementSystemActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SYSTEM_SUCCESS: {
      setLocalStorageData(
        ReferralManagementSystemActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SYSTEM_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ReferralManagementSystemActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SYSTEM_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default ReferralMgmtSystemReducer;
